import { Injectable } from '@angular/core';

@Injectable()
export default class StakeConvertService {
    convert(stake: number | null): string {
        if (stake == null) {
            return '';
        }
        const hasCents = (stake * 100) % 100 > 0;
        if (hasCents) {
            return stake.toFixed(2);
        }

        return '' + stake;
    }
}
